export const COLUMN_DEFINITIONS = [
    {
        id: 'requestId',
        header: 'Request ID',
        cell: (item: any) => item.requestId,
        sortingField: 'requestId',
        minWidth: 180
    },
    {
        id: 'swiftReadableId',
        header: 'SWIFT ID',
        cell: (item: any) => item.swiftReadableId,
        minWidth: 180
    },
    {
        id: "state",
        header: "State",
        cell: (e: any) => e.state,
        minWidth: 180
    },
    {
        id: "requestDate",
        header: "Request date",
        cell: (e: any)  => e.requestDate,
        sortingField: "requestDate",
        minWidth: 150
    },
    {
        id: "trackingStageType",
        header: "Tracking stage",
        cell: (e: any) => e.trackingStageType,
        sortingField: "trackingStage.trackingStageType",
        width: 180,
    },
    {
        id: "requester",
        header: "Requester",
        cell: (e: any) => e.requester,
        sortingField: "requester",
        minWidth: 130
    },
    {
        id: "source",
        header: "Source",
        cell: (e: any) => e.source,
        sortingField: "source",
        minWidth: 80
    },
    {
        id: "destination",
        header: "Destination",
        cell: (e: any) => e.destination,
        sortingField: "destination",
        minWidth: 140
    },
    {
        id: "ipn",
        header: "IPN",
        cell: (e: any) => e.ipn,
        minWidth: 180
    },
    {
        id: "mpn",
        header: "MPN",
        cell: (e: any) => e.mpn,
        minWidth: 180
    },
    {
        id: "quantityOrdered",
        header: "Quantity ordered",
        cell: (e: any) => e.quantityOrdered,
        minWidth: 120
    },
    {
        id: "itemCategory",
        header: "Item category",
        cell: (e: any) => e.itemCategory,
        sortingField: "itemCategory",
        minWidth: 160
    },
    {
        id: "projectTag",
        header: "Project tag",
        cell: (e: any) => e.projectTag,
        sortingField: "projectTag",
        minWidth: 250
    },
    {
        id: "shipmentId",
        header: "Shipment ID",
        cell: (e: any) =>  e.shipmentId,
        minWidth: 190
    },
    {
        id: "deliveryId",
        header: "Delivery ID",
        cell: (e: any) =>  e.deliveryId,
        minWidth: 190
    },
    {
        id: 'partId',
        header: 'Part ID',
        cell: (item: any) => item.partId,
        minWidth: 280,
        width: 300
    },
    {
        id: "transactionId",
        header: "Transaction ID",
        cell: (e: any) =>  e.transactionId,
        minWidth: 200,
        width: 300,
    },
    {
        id: "shippedDate",
        header: "Shipped date",
        cell: (e: any) => e.shippedDate,
        minWidth: 150
    },
    {
        id: "estimatedDeliveryDate",
        header: "Estimated delivery date",
        cell: (e: any) => e.estimatedDeliveryDate,
        minWidth: 180
    },
    {
        id: "priority",
        header: "Priority",
        cell: (e: any) => e.priority,
        sortingField: "priority",
        minWidth: 120
    },
    {
        id: "quantityReceived",
        header: "Quantity received",
        cell: (e: any) => e.quantityReceived,
        minWidth: 180
    },
    {
        id: "quantityAllocated",
        header: "Quantity allocated",
        cell: (e: any) => e.quantityAllocated,
        minWidth: 180
    },
    {
        id: "needByDate",
        header: "Need-by date",
        cell: (e: any) => e.needByDate,
        sortingField: "needByDate",
        minWidth: 160
    },
    {
        id: "shippedQuantity",
        header: "Shipped quantity",
        cell: (e: any) => e.shippedQuantity,
        minWidth: 80
    },
    {
        id: "trackingNumber",
        header: "Tracking number",
        cell: (e: any) => e.trackingNumber,
        minWidth: 210,
        width: 230
    },
    {
    id: "carrier",
    header: 'Carrier',
    cell: (item: any) => item.carrier,
    sortingField: "carrier"
    }
];

export const DEFAULT_PREFERENCES = {
    pageSize: 20,
    stickyColumns: {
        first: 0
    },
    visibleContent: [
        'requestId', 'state', 'requestDate', 'requester', 'destination', 'ipn', 'quantityOrdered',
        'itemCategory', 'projectTag', 'shipmentId', 'shippedDate', 'estimatedDeliveryDate'
    ],
    wrapLines: true,
};

export const PAGE_SIZE_OPTIONS = [
    { value: 10, label: '10 Entries' },
    { value: 20, label: '20 Entries' },
    { value: 30, label: '30 Entries' },
];

export const VISIBLE_CONTENT_OPTIONS = [
    {
        label: 'Primary columns',
        options: [
            { id: 'requestId', label: 'Request ID', editable: false },
            { id: 'swiftReadableId', label: 'SWIFT ID'},
            { id: 'state', label: 'State' },
            { id: 'trackingStageType', label: 'Tracking stage' },
            { id: 'requestDate', label: 'Request date' },
            { id: 'requester', label: 'Requester' },
            { id: 'destination', label: 'Destination' },
            { id: 'ipn', label: 'IPN' },
            { id: 'mpn', label: 'MPN' },
            { id: 'quantityOrdered', label: 'Quantity ordered' },
            { id: 'itemCategory', label: 'Item category' },
            { id: 'projectTag', label: 'Project tag' },
            { id: 'shippedDate', label: 'Shipped date' },
            { id: 'shipmentId', label: 'Shipment ID' },
            { id: 'deliveryId', label: 'Delivery ID' },
            { id: 'transactionId', label: 'Transaction ID' },
            { id: 'partId', label: 'Part ID' },
            { id: 'estimatedDeliveryDate', label: 'Estimated delivery date' },
            { id: 'trackingNumber', label: 'Tracking number'},
            { id: 'carrier', label: 'Carrier'}
        ],
    },
    {
        label: 'Secondary columns',
        options: [
            { id: 'priority', label: 'Priority' },
            { id: 'quantityReceived', label: 'Quantity received' },
            { id: 'quantityAllocated', label: 'Quantity allocated' },
            { id: 'needByDate', label: 'Need-by date' },
            { id: 'source', label: 'Source' },
            { id: 'shippedQuantity', label: 'Shipped quantity'}
        ],
    }
];

export const MAX_SUPPORTED_INPUTS = 1000;

export const MAX_SUPPORTED_HITS = 10000;

export const MORE_FILTERS = "MORE_FILTERS"

export const REQUEST_HISTORY_VIEW = "RequestHistoryView"

export const moreFiltersPriorityOptions = [
    {label:"Any", value:"any"},
    {label:"Sev-2", value:"SEV2"},
    {label:"Standard", value:"STANDARD"}
];

export const moreFiltersSourceOptions = [
    {label:"RAD001", value:"RAD001"},
    {label:"RDE001", value:"RDE001"},
    {label:"VMI-CVG", value:"VMI-CVG"},
    {label:"VMI-DUB", value:"VMI-DUB"},
    {label:"VMI-SIN", value:"VMI-SIN"},
    {label:"VMI-SLC", value:"VMI-SLC"}

]

export const documentTypeOptions = [
    {
      label: "Any document",
      value: "any",
    },
    {
      label: "Commercial Invoice",
      value: "COMMERCIAL_INVOICE",
    },
    {
      label: "ABD Document",
      value: "ABD_DOCUMENT",
    },
    {
        label: "VAT Invoice",
        value: "VAT",
    },
];

export const DOCUMENT_CENTER_COLUMN_DEFINITIONS = [
    {
        id: 'shipmentId',
        header: 'Shipment ID',
        cell: (e: any) => e.shipmentId,
        minWidth: 180
    },
    {
        id: "documentId",
        header: "Document ID",
        cell: (e: any) => e.documentId,
        minWidth: 180
    },
    {
        id: 'requestId',
        header: 'Request ID',
        cell: (e: any) => e.requestId,
        minWidth: 300,
        width: 340
    },
    {
        id: 'swiftId',
        header: 'SWIFT ID',
        cell: (e: any) => e.swiftReadableId,
        minWidth: 180
    },
    {
        id: "documentStatus",
        header: "Document Status",
        cell: (e: any)  => e.documentStatus,
        minWidth: 150
    },
    {
        id: "documentName",
        header: "Document Name",
        cell: (e: any) => e.documentName,
        minWidth: 130
    },
    {
        id: "downloadDocuments",
        header: "Download Documents",
        cell: (e: any) => e.downloadDocuments,
        minWidth: 180
    }
]